/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class INGEApiConfiguration {
  rootUrl: string = 'https://api.skogsstyrelsen.se/sksapi';
}

/**
 * Parameters for `INGEApiModule.forRoot()`
 */
export interface INGEApiConfigurationParams {
  rootUrl?: string;
}
